// Bmi.ts
// Utility functions for Body Mass Index (BMI) calculations

/**
 * Calculates BMI given height (cm) and weight (kg)
 * @param heightCm Height in centimetres
 * @param weightKg Weight in kilograms
 * @returns BMI value rounded to one decimal place
 */
export function CalculateBmi(heightCm: number, weightKg: number): number {
    if (weightKg <= 0 || heightCm <= 0) {
        throw new Error('Weight and height must be positive numbers.');
    }

    const heightM = heightCm / 100;

    const bmi = weightKg / (heightM * heightM);
    return Math.round(bmi * 10) / 10;
}
